import React, {Component} from "react";
import {Link} from "react-router-dom";
import HeaderRight from "../layouts/HeaderRight";
import {post} from './../../networking/Api'
import Constent from './../../networking/Constent';
import {Alert} from "./../../alertServices";
import helpers from './../../networking/Helpers';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import CheckinPopup from "./CheckinPopup";

var location='';
class UserTimeregistration extends Component {
    constructor(props) {
        super(props);
        this.state={
        	   user_id : localStorage.getItem('userid'),
              user_list:[],
              timestamp_details: [],
              primary_key:'',
              start_date:'',
              end_date: '',
              date_range:'',
              date:'',
              
              total_paid_time: '00:00',
              total_break_time: '00:00',
              timestamp_id : '',  
              timestamp_detail_id:'',
              expireOpen:false,
              showPayment: false,
              isUserDetail:false,
              checkInStatus:true,
              enable_next_button : true,
              latitude:'',
              longitude:'',
              meeting_date:'',
              meeting_time:'',
              leaving_date:'',
              leaving_time:'',
              note:'',

              last_meeting_datetime:'',
              emp_edit:1,
              total_count : -1
        }

        if(navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(this.showPosition)
        } else {
          console.log("Geo Location not supported by browser");
        }
    }

    //function that retrieves the position
    showPosition(position) {
      location = {
        longitude: position.coords.longitude,
        latitude: position.coords.latitude
      }
    }
    
    componentDidMount(){
        this.handler();
        var userID = (localStorage.getItem('user_type') !== 'user') ? this.props.match.params.id : localStorage.getItem('userid');
        let guest_write_access = helpers.isIntegrationGuestWriteAccess(localStorage.getItem('integration_id'));
        this.setState({user_id:userID,guest_write_access:guest_write_access})

            let timestamp_option = localStorage.getItem('timestamp_option');
            let timesoption = JSON.parse(timestamp_option);
            
            let startDate = timesoption.date_range.start_date;
        	let endDate = timesoption.date_range.end_date;
            
        	var str=startDate;
	        str= str.split(" - "); //convert 'jQuery' to array
	        str = str.reverse(); //reverse 'jQuery' order 
	        str = str.join(" - ");
	        var strs=endDate;
	        strs= strs.split(" - "); //convert 'jQuery' to array
	        strs = strs.reverse(); //reverse 'jQuery' order 
	        strs = strs.join(" - ");
	        this.setState({start_date:str,end_date:strs});
	        
            if(localStorage.getItem('user_type') === 'user'){  
                this.setState({emp_edit:timesoption.emp_edit});
            }
            if(localStorage.getItem('user_type') === 'guest'){  
                this.setState({emp_edit:timesoption.guest_setting.emp_edit});
            }

            this.getTimeStampList(this.state.user_id,startDate,endDate);
            this.enableNextButton(endDate);

          if(timesoption.date_filter==="monthly"){
              this.setState({date_range:30})
          }
          if(timesoption.date_filter==="weekly"){
              this.setState({date_range:7})
          }
          if(timesoption.date_filter==="2_weekly"){
              this.setState({date_range:14})
          }
          if(timesoption.date_filter==="3_monthly"){
              this.setState({date_range:90})
          }
    }

    handler() {
       var userID = (localStorage.getItem('user_type') !== 'user') ? this.props.match.params.id : localStorage.getItem('userid');
       this.lastTimestampDetail(userID);        
    }

    lastTimestampDetail(userId){
      try {
        var timeStamp = helpers.getCurrentDateTime();    
        var formData=new FormData();
        formData.append("user_id",userId);
        formData.append("timeStamp",timeStamp);
        post(Constent.LASTTIMESTAMPDETAIL,formData).then(response=>{
            if(response.status===true){
              localStorage.setItem('checkin_projectid',"0"); 
              localStorage.setItem('checkin_projectname',''); 
              localStorage.setItem('meetDateTime',""); 
              this.setState({last_meeting_datetime:''});
                var status_code = response.status_code;
                if(status_code === 1){
                  localStorage.setItem('diff',""); 
                  localStorage.setItem("checkInStatus",true);
                  this.setState({checkInStatus:true});
                }else{
                  // already checkin
                  var meet = response.data.meet_time;
                  var momentCurrentTime =  moment(timeStamp,"YYYY-MM-DD HH:mm:ss");
                  var momentMeetTime =  moment(meet,"YYYY-MM-DD HH:mm:ss");
                  var ruleMeetTime = "";
                  var diff = '00:00';   
                  if(momentMeetTime > momentCurrentTime){
                     ruleMeetTime =  moment(meet,"YYYY-MM-DD HH:mm:ss").format("HH:mm");
                     diff = '00:00';     
                  }else{
                    ruleMeetTime = "";
                    diff = moment.utc(moment(timeStamp,"YYYY-MM-DD HH:mm:ss").diff(moment(meet,"YYYY-MM-DD HH:mm:ss"))).format("HH:mm") 
                  }
                  localStorage.setItem('diff',diff);
                  localStorage.setItem('ruleMeetTime',ruleMeetTime);  

                  var momentCustomMeetDateTime = moment(meet,"YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY - HH:mm");
                  localStorage.setItem("meetDateTime",momentCustomMeetDateTime);
                  this.setState({last_meeting_datetime:meet});
                  if(response.data.project_id !== 0){
                    localStorage.setItem("status","project");
                  }else if(response.shift_id !== 0){
                    localStorage.setItem("status","shift_id");
                  }else{
                    localStorage.setItem("status","time");
                  }
                  localStorage.setItem('checkInStatus',false); 
                   this.setState({checkInStatus:false});
                  if(response.project_id !== 0){
                    localStorage.setItem('checkin_projectid',response.project_id); 
                    localStorage.setItem('checkin_projectname',response.project_name); 
                  }
                }
            }else{
              localStorage.setItem("status","");
              localStorage.setItem('checkInStatus',true); 
              this.setState({checkInStatus:true});
            }
        })
      } catch(e) {
        console.log(e);
      }  
    }

    enableNextButton(endDate){
        var todayDate = helpers.getCurrentDate();

        endDate = moment(endDate, 'YYYY-MM-DD');
        todayDate = moment(todayDate, 'YYYY-MM-DD');
        if (endDate.isBefore(todayDate)) {
            this.setState({'enable_next_button':true});
        }else{
            this.setState({'enable_next_button':false});
        }
    }

    getTimeStampList(user_id,start,end){
      var userID = (localStorage.getItem('user_type') !== 'user') ? user_id : localStorage.getItem('userid');
      var formData=new FormData();
      formData.append("user_id",userID);
      formData.append("start_date",start);
      formData.append("end_date",end);
      post(Constent.USERTIMESTAMP,formData).then(response=>{
          if(response.status===1){
            var str=response.startDate;
            str= str.split("-"); //convert 'jQuery' to array
            str = str.reverse(); //reverse 'jQuery' order 
            str = str.join("-");
            var strs=response.endDate;
            strs= strs.split("-"); //convert 'jQuery' to array
            strs = strs.reverse(); //reverse 'jQuery' order 
            strs = strs.join("-");
            this.setState({
                start_date:str,
                end_date:strs,
                user_list:response.data,
                total_count:response.data.length,
                total_paid_time:response.total_paid_time,
                total_break_time:response.total_break_time,
            })
            this.enableNextButton(strs);
          }
      })
  }
   

    startdt=()=>{
        var str=this.state.start_date;
        str= str.split("-"); //convert 'jQuery' to array
        str = str.reverse(); //reverse 'jQuery' order 
        str = str.join("/");
        return str;
    }
    enddt=()=>{
        var str=this.state.end_date;
        str= str.split("-"); //convert 'jQuery' to array
        str = str.reverse(); //reverse 'jQuery' order 
        str = str.join("/");
        return str;
    }

    handleExpireOpen = () => {
      this.setState({ expireOpen: true });
    };

    handleExpireClose = () => {
       this.setState({ expireOpen: false });
    };

    handleShowPayment = () => {
      this.setState({ showPayment: true });
    }

    handledelet = () => {
        var formData=new FormData();
        formData.append("user_id", this.state.user_id);
        formData.append("timestamp_detail_id",this.state.timestamp_detail_id);
        post(Constent.DELETIMESTAMEDETAIL,formData).then(response=>{
           if(response.status===1){
              window['modalClose']();
              Alert.success({title: response.msg});
              this.getTimeStampList(this.state.user_id,this.state.start_date,this.state.end_date);
            }else{
                Alert.error({title: response.msg});
            }
        });
    };

    handledeletBreak = () => {
        var formData=new FormData();
        formData.append("user_id",this.state.user_id);
        formData.append("primary_key",this.state.primary_key);
        post(Constent.DELETETIMESTAMPBREAK,formData).then(response=>{
           if(response.status===1){
              window['modalClose']();
              Alert.success({title: response.message});
              this.getTimeStampList(this.state.user_id,this.state.start_date,this.state.end_date);
            }else{
                Alert.error({title: response.message});
            }
        });
    };


    addTimestamp = () => {
    var meeting_date= this.state.meeting_date;
        meeting_date= meeting_date.split("-"); //convert 'jQuery' to array
        meeting_date = meeting_date.reverse(); //reverse 'jQuery' order 
        meeting_date = meeting_date.join("-");  

    var startDateTime = meeting_date + ' ' + this.state.meeting_time,
        endDateTime = meeting_date + ' ' + this.state.leaving_time;
        startDateTime = moment(startDateTime, 'DD-MM-YYYY HH:mm');
        endDateTime = moment(endDateTime, 'DD-MM-YYYY HH:mm');
        if (endDateTime.isBefore(startDateTime)) {
            endDateTime = endDateTime.add(1, "days");
        }
    var leaving_date = moment(endDateTime).format('DD-MM-YYYY'); 

   var formData=new FormData();
   formData.append("latitude",location.latitude);
   formData.append("longitude",location.longitude);
   formData.append("meeting_date",meeting_date);
   formData.append("meeting_time",this.state.meeting_time);
   formData.append("leaving_date",leaving_date);
   formData.append("leaving_time", (this.state.leaving_time === '00:00' ? '' : this.state.leaving_time ));
   formData.append("note",this.state.note);
   formData.append("user_id",this.state.user_id);
   formData.append("deviceType","mobile manually");
   formData.append("selected_date",this.state.meeting_date);
   post(Constent.ADDTIMESTAMP,formData).then(response=>{
      if(response.flag===1){
          window['modalClose']();
          Alert.success({title: response.msg});
         this.getTimeStampList(this.state.user_id,this.state.start_date,this.state.end_date);
       }else{
         Alert.error({title: response.msg});
       }
   })
 };

    updateTimestamp = () => {
        var meeting_date= this.state.meeting_date;
        meeting_date= meeting_date.split("-"); //convert 'jQuery' to array
        meeting_date = meeting_date.reverse(); //reverse 'jQuery' order 
        meeting_date = meeting_date.join("-");  

    var startDateTime = meeting_date + ' ' + this.state.meeting_time,
        endDateTime = meeting_date + ' ' + this.state.leaving_time;
        startDateTime = moment(startDateTime, 'DD-MM-YYYY HH:mm');
        endDateTime = moment(endDateTime, 'DD-MM-YYYY HH:mm');
        if (endDateTime.isBefore(startDateTime)) {
            endDateTime = endDateTime.add(1, "days");
        }
    var leaving_date = moment(endDateTime).format('DD-MM-YYYY');   


        var formData=new FormData();
           formData.append("timestamp_detail_id", this.state.timestamp_detail_id);
           formData.append("meeting_date",meeting_date);
           formData.append("meeting_time",this.state.meeting_time);
           formData.append("leaving_date",leaving_date);
           formData.append("leaving_time", (this.state.leaving_time === '00:00' ? '' : this.state.leaving_time ));
           formData.append("note",this.state.note);
           formData.append("user_id",this.state.user_id);
           formData.append("date",this.state.meeting_date);
           
       post(Constent.EDITTIMESTAMP,formData).then(response=>{
            window['modalClose']();
            if(response.status===1){
                Alert.success({title: response.msg});
                this.getTimeStampList(this.state.user_id,this.state.start_date,this.state.end_date);
            }else{
                Alert.error({title: response.msg});
           }
       })
     };


    addBreak = () => {
        var meeting_date= this.state.meeting_date;
            meeting_date= meeting_date.split("-"); //convert 'jQuery' to array
            meeting_date = meeting_date.reverse(); //reverse 'jQuery' order 
            meeting_date = meeting_date.join("-");  

        var startDateTime = meeting_date + ' ' + this.state.meeting_time,
            endDateTime = meeting_date + ' ' + this.state.leaving_time;
            startDateTime = moment(startDateTime, 'DD-MM-YYYY HH:mm');
            endDateTime = moment(endDateTime, 'DD-MM-YYYY HH:mm');
            if (endDateTime.isBefore(startDateTime)) {
                endDateTime = endDateTime.add(1, "days");
            }
        //var leaving_date = moment(endDateTime).format('DD-MM-YYYY'); 

       var formData=new FormData();
       formData.append("timestamp_id",this.state.timestamp_id);
       formData.append("break-from[]",this.state.meeting_time);
       formData.append("break-to[]", (this.state.leaving_time === '00:00' ? '' : this.state.leaving_time ));
       post(Constent.ADDTIMESTAMPBREAK,formData).then(response=>{
          if(response.flag===1){
              window['modalClose']();
              Alert.success({title: response.msg});
             this.getTimeStampList(this.state.user_id,this.state.start_date,this.state.end_date);
           }else{
             Alert.error({title: response.msg});
           }
       })
     };

     updateBreak = () => {
        // var meeting_date= this.state.meeting_date;
        //     meeting_date= meeting_date.split("-"); //convert 'jQuery' to array
        //     meeting_date = meeting_date.reverse(); //reverse 'jQuery' order 
        //     meeting_date = meeting_date.join("-");  

        // var startDateTime = meeting_date + ' ' + this.state.meeting_time,
        //     endDateTime = meeting_date + ' ' + this.state.leaving_time;
        //     startDateTime = moment(startDateTime, 'DD-MM-YYYY HH:mm');
        //     endDateTime = moment(endDateTime, 'DD-MM-YYYY HH:mm');
        //     if (endDateTime.isBefore(startDateTime)) {
        //         endDateTime = endDateTime.add(1, "days");
        //     }
        // var leaving_date = moment(endDateTime).format('DD-MM-YYYY'); 

       var formData=new FormData();
       formData.append("primary_key",this.state.primary_key);
       formData.append("break-from",this.state.meeting_time);
       formData.append("break-to", (this.state.leaving_time === '00:00' ? '' : this.state.leaving_time ));
       post(Constent.UPDATETIMESTAMPBREAK,formData).then(response=>{
          if(response.flag===1){
              window['modalClose']();
              Alert.success({title: response.msg});
             this.getTimeStampList(this.state.user_id,this.state.start_date,this.state.end_date);
           }else{
             Alert.error({title: response.msg});
           }
       })
     };

    changeCheckIn = (checkInStatus) => {
       this.setState({checkInStatus: checkInStatus});
    }
    render() {
        const { t } = this.props;
        return (
            <>
            {/* Navigation Bar Imported from Layouts */}
                {/* Header Starts */}

                <div className="header-area timeregistraionpage" style={{'borderRadius': 0}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-3 col-3">
                                <Link className="menu-back-page home-clicked" to={'/'}>
                                    <i className="fa fa-home" />
                                </Link>
                            </div>
                            <div className="col-sm-6 col-6 text-center">
                                <div className="page-name">{t('lang.menu_name_time_registration')}</div>
                            </div>
                            <div className="col-sm-3 col-3 text-right">
                               <HeaderRight />
                            </div>
                        </div>
                    </div>
                </div>

                <div className=" mg-top-50 sub-header">
                    <div className="container">
                        <div className="row action-row">
                            <div className="col-6 text-overflow">
                            {(localStorage.getItem('user_type') !== 'user') ?
                                <><img src={JSON.parse(localStorage.getItem('user_data')).profile_image} alt="img" />
                                <div>
                                    <span className="name">{JSON.parse(localStorage.getItem('user_data')).name}</span>
                                    <div className="group">{JSON.parse(localStorage.getItem('user_data')).job_title}</div>
                                </div></>
                            : '' }    
                            </div>
                            <div className="col-6">
                               <span className="period">
                                {/* {t('lang.filter_text_period')}:  */}
                                { this.startdt().substring(0, 5)} - {this.enddt().substring(0, 5)}</span>
                            </div>
                             
                        </div>
                        <div className="row action-row" style={{marginTop: 10}}>
                            <div className="col-6">
                            </div>
                            <div className="col-6">
                                <span className="previous"
                                onClick={() => {
                                  this.setState({end_date:this.state.start_date});    
                                  var date1 = new Date(this.state.start_date);
                                    date1.setDate(date1.getDate()-this.state.date_range);
                                    var neweDate=date1.toISOString();
                                    neweDate=neweDate.split("T");
                                    this.setState({start_date:neweDate[0]});
                                    this.getTimeStampList(this.state.user_id,neweDate[0],this.state.start_date);
                                    }}>{t('lang.filter_text_prev')}</span>
                                {this.state.enable_next_button === true ?
                                <span className="next"
                                    onClick={() => {
                                    var date1 = new Date(this.state.end_date);
                                    date1.setDate(date1.getDate() + this.state.date_range)
                                    var neweDate=date1.toISOString();
                                    neweDate=neweDate.split("T");
                                    this.setState({end_date:neweDate[0]});
                                    this.getTimeStampList(this.state.user_id,this.state.end_date,neweDate[0]);
                                    }}>{t('lang.filter_text_next')}</span>
                                    : ''}
                                   
                            </div>
                        </div>
                    </div>
                </div>

                
                <div className="timeregistraion transaction-area pd-top-15 mg-bottom-40">
                        {this.state.total_count < 0 ? <p className="text-center">{t('lang.common_text_loading') }</p> : '' }
                        {this.state.user_list.map(({ date, timestamp_id, schema_start,schema_end,meet,leave,total_time,note,show_more,user_id,selected_date, timestamp_details ,is_break,is_note}) => (
                        
                        <div className="single-goal" key={date}
                        onClick={() => {
                          this.setState({date:date, timestamp_details:timestamp_details, selected_date:selected_date, timestamp_id: timestamp_id});
                        }}
                        >
                            <div className="row" data-toggle="modal" data-target="#timedetails-modal">
                                <div className="col-6 pr-0">
                                    <div className="details">
                                        <h6>{date.substring(0,3)}</h6>
                                        <p>{ (date.substring(6,20)).replaceAll('-','/')}</p>
                                    </div>
                                </div>
                                <div className="col-6 text-right">
                                    <div className="details">
                                {(selected_date === moment(this.state.last_meeting_datetime,"YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD") )? 
                                <>
                                    {(this.state.checkInStatus === false) ?
                                     <h6><span className="working"> <i className="fa fa-circle"></i> {t('lang.flex_sc_working')} </span><small>{moment(this.state.last_meeting_datetime,"YYYY-MM-DD HH:mm:ss").format("HH:mm")}</small></h6>
                                    : <h6 className="not-working"> <i className="fa fa-circle"></i>{t('lang.flex_sc_free')}</h6>
                                    }
                                </> : ''}

                                { (timestamp_details.length > 0) ?   
                                    <>
                                    {timestamp_details.map(({ timestamp_detail_id,meeting, leaving,type }) => (
                                         ( (leaving !== '') && (type !== 'break')) ?
                                         <div key={timestamp_detail_id}><span>{ meeting}</span><span> - </span><span>{leaving}</span></div>
                                         : <div key={Math.random()}></div>
                                    ))} </>
                                : '' }
                                    <p className="hours">
                                        { is_break === true ? <i className="fa fa-coffee" aria-hidden="true"></i> : ''}

                                        { is_note === true ? <i className="fa fa-sticky-note-o" aria-hidden="true"></i>: ''}
                                        {t('lang.common_text_hours')}  : <strong>{ total_time !== '' ?  total_time : '00:00'}</strong>  </p>
                                    </div>  
                                </div>
                            </div>
                        </div>
                        ))}
                </div>
                {/* transaction End */}

               

            {/* Timeregistration details modal  start  */}
            <div id="timedetails-modal" className="modal modal-top fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content" style={{'background':'#F5F5F5'}}>
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.flex_sc_stamp_of')} {this.state.date.substring(0,3)} {this.state.date.substring(6,20).replaceAll('-','/')}</h5>
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                            
                        </div>
                        <div className="modal-body" style={{'paddingRight':0,'paddingLeft':0}}>
                        { (this.state.timestamp_details.length > 0) ? 
                            <div className="row" style={{'marginRight': 0,'marginLeft': 0}}>
                                  <div className="col-2">
                                  </div>
                                  <div className="col-3">
                                    {t('lang.timestamp_sc_meet')} 
                                  </div>
                                  <div className="col-3">
                                    {t('lang.timestamp_sc_leave')}
                                  </div>
                                  <div className="col-4">
                                    {t('lang.timestamp_sc_time')}
                                  </div>
                            </div>
                        : <div className="col-12 text-center">{t('lang.message__no_record_available')}</div> }      
                        {this.state.timestamp_details.map((item) =>   
                            <div className="single-goal" key={Math.random()} style={{'paddingTop': 9,'paddingBottom': 7}}>
                                <div className="row" style={{'marginRight': 0,'marginLeft': 0}}>
                                  <div className="col-2 center">
                                  {item.type !== 'break' ? 
                                    <i className="las la-clock time-icon bg-theme"></i>
                                    : <i className="las la-coffee break-icon"></i>}
                                  </div>
                                  
                                    <div className={ (item.type === 'break') ? 'col-8 mgTp13' : 'col-8'} >
                                        <div className="row">

                                            <div className="col-4" style={{'textDecoration': 'underline'}}>
                                                <Link to={'#'} 
                                                data-toggle="modal" data-target={item.type !== 'break' ? '#edit-timestamp-modal' : '#edit-break-modal'}
                                                onClick={()=>{
                                                  this.setState({
                                                    primary_key: item.id,
                                                    meeting_date:this.state.selected_date,
                                                    meeting_time:item.meeting,
                                                    leaving_time:item.leaving,
                                                    note:item.note,
                                                    timestamp_detail_id: item.timestamp_detail_id
                                                    })
                                                }}>
                                                    {item.meeting} 
                                                </Link>
                                            </div>
                                            <div className="col-4 text-center" style={{'textDecoration': 'underline'}}
                                            data-target="#edit-timestamp-modal" >
                                                <Link to={'#'} 
                                                data-toggle="modal" data-target={item.type !== 'break' ? '#edit-timestamp-modal' : '#edit-break-modal'}
                                                onClick={()=>{
                                                  this.setState({
                                                    primary_key: item.id,
                                                    meeting_date:this.state.selected_date,
                                                    meeting_time:item.meeting,
                                                    leaving_time:item.leaving,
                                                    note:item.note,
                                                    timestamp_detail_id: item.timestamp_detail_id})
                                                }}>
                                                { (item.leaving !== '') ? item.leaving : '--:--' }
                                                </Link>
                                            </div>
                                            <div className="col-4 text-center">
                                                <span className="color-green">{ item.total_time }</span>
                                            </div>
                                            {item.type !== 'break' ? 
                                            <div className="col-12" style={{'marginTop': 7,'marginBottom': 7}}>
                                                <input type="text" value={(item.note) ? item.note : ''} placeholder={t('lang.flex_sc_the_note_here')} style={{width:'100%'}} readOnly={true}/>
                                            </div> : ''}
                                        </div>
                                    </div>
                                    <div className="col-2 center">
                                    {(this.state.emp_edit === 1) ? 

                                        <i className="las la-times-circle clear-icon" 
                                        onClick={()=>{
                                          if( helpers.isIntegrationExpired(localStorage.getItem('integration_id'))){
                                            this.handleExpireOpen();
                                        }else{
                                            Alert.delete({
                                                position:'toast-top-full-width',
                                                message:t('lang.message_this_data_wont_be_retrievable_once_deleted_are_you_sure'),
                                                btn_yes:t('lang.btn_text_yes_do_it'),
                                                action: () =>{   
                                                        this.setState({ timestamp_detail_id:item.timestamp_detail_id,primary_key:item.id })
                                                    if(item.type !== 'break'){
                                                        this.handledelet();
                                                    }else{
                                                        this.handledeletBreak();
                                                    }
                                                }
                                            })
                                        }
                                        }}></i>
                                    : ''}    
                                  </div>  
                                </div>
                            </div>
                        )}    
                            <div className="form-group basic center footer-action">
                            { (this.state.emp_edit === 1) ?    
                                <>
                                { (this.state.timestamp_details.length > 0) ?
                                <Link to={'#'} className="add-break-btn center" 
                                    data-toggle="modal" data-target="#add-break-modal"
                                    onClick={()=>{
                                      this.setState({
                                        meeting_time:'',
                                        leaving_time:''})
                                    }}
                                    >
                                    <i className="las la-coffee"></i>{t('lang.timestamp_sc_add_break')}
                                </Link>
                                : ''}
                                <Link to={'#'} className="add-record-btn center" 
                                    data-toggle="modal" data-target="#add-timestamp-modal"
                                    onClick={()=>{
                                      this.setState({
                                        meeting_date:this.state.selected_date,
                                        meeting_time:'',
                                        leaving_time:'',
                                        note:'',
                                        timestamp_detail_id: ''})
                                    }}
                                    >
                                    <i className="las la-plus"></i> {t('lang.common_text_add_record')}
                                </Link>
                                </>
                                :''}
                            </div>
                                
                        </div>
                    </div>
                </div>
              </div>  
            {/* Timeregistration details modal end  */}
            

            {/* Check in popip end  */}
                <CheckinPopup setCheckInStatus = {this.changeCheckIn}  checkinoutScreen="time" p_userid={this.state.user_id}/>
            {/* Checkin popup end  */}

           {(localStorage.getItem('user_type') !== 'user') ?
            <Link to={'#'} className="add-btn-right" 
            data-toggle="modal" data-target="#add-timestamp-modal"
            onClick={()=>{
              this.setState({
                meeting_date:'',
                meeting_time:'',
                leaving_time:'',
                note:'',
                timestamp_detail_id: ''})
            }}
            >
                <i className="las la-plus"></i>
            </Link>
            :''}

            {/* Footer start */}
            <div className="footer-area">
                <div className="container">
                    <div className="footer-bottom text-center">
                        <div className="row center">
                            <div className="col-3">
                              
                            </div>
                            <div className="col-7">
                                <div><span>{t('lang.timestamp_sc_paid_time')}:  {this.state.total_paid_time} </span></div>
                                <div><span>{t('lang.home_sc_break_time')}: {this.state.total_break_time} </span></div>
                            </div>
                            <div className="col-2">
                                {(localStorage.getItem('user_type') !== 'user') ?
                                    <Link className="home-clicked" to={'/timeregistration-userlist'}>
                                        <i className="fa fa-reply" />
                                    </Link>
                                : 
                                    <Link className="home-clicked" to={'/'}>
                                        <i className="fa fa-home" />
                                    </Link>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Footer End */}


        {/*  add-timestamp-modal start */}
            <div id="add-timestamp-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.timestamp_sc_add_timestamp')}</h5>
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="action-sheet-content">
                               
                                <span className="label">{t('lang.timestamp_sc_meeting_date')}</span>
                                <div className="input-group mb-4">
                                    <input type="date" className="form-control form-control-lg"
                                    value={this.state.meeting_date}
                                    max={helpers.getCurrentDate()} 
                                    onChange={e => { this.setState({meeting_date: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.timestamp_sc_meeting_time')}</span>
                                <div className="input-group mb-4">
                                    <input type="time" className="form-control form-control-lg"
                                    value={this.state.meeting_time} 
                                    onChange={e => { this.setState({meeting_time: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.timestamp_sc_leaving_time')}</span>
                                <div className="input-group mb-4">
                                    <input type="time" className="form-control form-control-lg"
                                    value={this.state.leaving_time} 
                                    onChange={e => { this.setState({leaving_time: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.timestamp_sc_note')}</span>
                                <div className="input-group mb-4">
                                    <input type="text" className="form-control form-control-lg"
                                    value={(this.state.note) ? this.state.note : ''} 
                                    onChange={e => { this.setState({note: e.target.value})}} />
                                </div>

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-shadow" data-dismiss="modal">{t('lang.modal_btn_close')}</button>
                            <button type="button" className="btn btn-primary" onClick={()=>{this.addTimestamp()}}>{t('lang.modal_btn_save')}</button>
                        </div>
                    </div>
                </div>
            </div>


        {/*  edit-timestamp-modal start */}
            <div id="edit-timestamp-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.timestamp_sc_edit_timestamp')}</h5>
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="action-sheet-content">
                               
                                <span className="label">{t('lang.timestamp_sc_meeting_time')}</span>
                                <div className="input-group mb-4">
                                    <input type="time" className="form-control form-control-lg"
                                    value={this.state.meeting_time} 
                                    onChange={e => { this.setState({meeting_time: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.timestamp_sc_leaving_time')}</span>
                                <div className="input-group mb-4">
                                    <input type="time" className="form-control form-control-lg"
                                    value={this.state.leaving_time} 
                                    onChange={e => { this.setState({leaving_time: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.timestamp_sc_note')}</span>
                                <div className="input-group mb-4">
                                    <input type="text" className="form-control form-control-lg"
                                    value={(this.state.note) ? this.state.note : ''} 
                                    onChange={e => { this.setState({note: e.target.value})}} />
                                </div>

                            </div>
                        </div>
                        {(this.state.emp_edit === 1) ?
                        <div className="modal-footer">
                            <button type="button" className="btn btn-shadow" data-dismiss="modal">{t('lang.modal_btn_close')}</button>
                            <button type="button" className="btn btn-primary" onClick={()=>{this.updateTimestamp()}}>{t('lang.modal_btn_save')}</button>
                        </div>
                        : ''}
                    </div>
                </div>
            </div>

        {/*  add-break-modal start */}
            <div id="add-break-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.timestamp_sc_add_break')}</h5>
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="action-sheet-content">
                               
                                <span className="label">{t('lang.timestamp_sc_meeting_time')}</span>
                                <div className="input-group mb-4">
                                    <input type="time" className="form-control form-control-lg"
                                    value={this.state.meeting_time} 
                                    onChange={e => { this.setState({meeting_time: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.timestamp_sc_leaving_time')}</span>
                                <div className="input-group mb-4">
                                    <input type="time" className="form-control form-control-lg"
                                    value={this.state.leaving_time} 
                                    onChange={e => { this.setState({leaving_time: e.target.value})}} />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-shadow" data-dismiss="modal">{t('lang.modal_btn_close')}</button>
                            <button type="button" className="btn btn-primary" onClick={()=>{this.addBreak()}}>{t('lang.modal_btn_save')}</button>
                        </div>
                    </div>
                </div>
            </div>


        {/*  edit-break-modal start */}
            <div id="edit-break-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.timestamp_sc_edit_break')}</h5>
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="action-sheet-content">
                               
                                <span className="label">{t('lang.timestamp_sc_meeting_time')}</span>
                                <div className="input-group mb-4">
                                    <input type="time" className="form-control form-control-lg"
                                    value={this.state.meeting_time} 
                                    onChange={e => { this.setState({meeting_time: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.timestamp_sc_leaving_time')}</span>
                                <div className="input-group mb-4">
                                    <input type="time" className="form-control form-control-lg"
                                    value={this.state.leaving_time} 
                                    onChange={e => { this.setState({leaving_time: e.target.value})}} />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-shadow" data-dismiss="modal">{t('lang.modal_btn_close')}</button>
                            <button type="button" className="btn btn-primary" onClick={()=>{this.updateBreak()}}>{t('lang.modal_btn_save')}</button>
                        </div>
                    </div>
                </div>
            </div>
            </>
        );
    }
}

export default withTranslation('common')(UserTimeregistration);